import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

export const RouteError: FC = () => {
  useTranslation();
  const error = useRouteError();
  return (
    <div>
      <p><Trans ns="app" i18nKey="error"/></p>
      <p>{JSON.stringify(error)}</p>
    </div>
  );
};
